import { ApostilleCountries } from 'todistukset-common/src/vtj/ApostilleCountries.enum'
import { EuCountries } from 'todistukset-common/src/vtj/EuCountries.enum'
import {
  getCountriesShortNames,
  ValtioKoodistoEntry,
  type CountryKoodistoCode,
} from 'todistukset-common/src/vtj/vtj-koodisto.util'

const isCountryInEnum = (
  countryCode: CountryKoodistoCode | undefined | null,
  compEnum: Record<string, string>
): boolean => !!countryCode && Object.values(compEnum).includes(countryCode)

export const isCountryInApostilleByCode = (
  countryCode: CountryKoodistoCode | undefined | null
): boolean => {
  return isCountryInEnum(countryCode, ApostilleCountries)
}

export const isCountryInEUByCode = (
  countryCode: CountryKoodistoCode | undefined | null
): boolean => {
  return isCountryInEnum(countryCode, EuCountries)
}

export const getAllCountries = (
  includeFormerCountries = true
): ValtioKoodistoEntry[] => {
  return getCountriesShortNames(includeFormerCountries)
}

export const getValtioKoodistoEntryByCode = (
  koodistoCode: string | undefined | null
): ValtioKoodistoEntry | undefined => {
  return getCountriesShortNames(true).find(
    (country) => country.koodistoCode === koodistoCode
  )
}
